import { Component, OnInit } from '@angular/core';
import { SenLoaderService } from "./sen-loader.service";

@Component({
  selector: 'sen-app-loader',
  templateUrl: './sen-loader.component.html',
  styleUrls: ['./sen-loader.component.scss']
})
export class SenLoaderComponent implements OnInit {
  loading: boolean;

  constructor(private loaderService: SenLoaderService) {
    this.loaderService.isLoading.subscribe((v) => {
      setTimeout(() => {
        this.loading = v;
      }, 100);
    });
  }

  ngOnInit(): void {
  }
}
